<template>
  <v-layout
    :title="$t('customer_service.title')"
    :subtitle="$t('customer_service.subtitle')"
  >
    <HelpPage :topics="topics" />
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import HelpPage from "@/components/HelpPage";

export default {
  components: {
    VLayout,
    HelpPage,
  },
  computed: {
    topics() {
      return [
        {
          title: this.$t("customer_service.no_received"),
          text: this.$t("customer_service.no_received_text"),
        },
        {
          title: this.$t("customer_service.localize_order"),
          text: this.$t("customer_service.localize_order_text"),
        },
        {
          title: this.$t("customer_service.contact"),
          text: this.$t("customer_service.contact_text"),
        },
        {
          title: this.$t("customer_service.change_data"),
          text: this.$t("customer_service.change_data_text"),
        },
      ];
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        customer_service: {
          title: "Customer service",
          subtitle: "Help center",
          breadcrumb: "Customer service",
          no_received: "Order delivered, but not received",
          no_received_text: "",
          contact: "Contact us",
          contact_text: "",
          localize_order: "Find your order",
          localize_order_text: "",
          change_data: "Change your personal information",
          change_data_text: "",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
